// removed by extract-text-webpack-plugin
module.exports = {"studentsNavGrid":"src-components-StudentsNavGrid----StudentsNavGrid-module---studentsNavGrid---2ND8H","header":"src-components-StudentsNavGrid----StudentsNavGrid-module---header---1WeaQ","grid":"src-components-StudentsNavGrid----StudentsNavGrid-module---grid---3hYrG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StudentsNavGrid/StudentsNavGrid.module.scss
// module id = 124
// module chunks = 29990747609436 213534597649335